import * as Accordion from '@radix-ui/react-accordion';

import { openNavStyles } from '@/components/modules/app-navigation/open';

import { OpenItemHeaderContent } from './content';

export interface OpenItemHeaderProps {
  isOpen?: boolean;
  label: string;
  parentIsActive?: boolean;
  visibility: 'visible' | 'hidden';
  iconComponent: any;
  showNotificationDot?: boolean;
  notificationContent?: string;
  hasSubItems?: boolean;
}

const OpenItemHeader = ({
  isOpen,
  parentIsActive,
  iconComponent,
  showNotificationDot,
  notificationContent,
  visibility,
  label,
  hasSubItems,
}: OpenItemHeaderProps) => {
  const { header, trigger, triggerBg } = openNavStyles({
    isOpen,
  });

  return (
    <Accordion.Header className={header()}>
      <Accordion.Trigger className={trigger({ isOpen: parentIsActive })}>
        <OpenItemHeaderContent
          label={label}
          iconComponent={iconComponent}
          parentIsActive={parentIsActive}
          visibility={visibility}
          isOpen={isOpen}
          showNotificationDot={showNotificationDot}
          notificationContent={notificationContent}
          hasSubItems={hasSubItems}
        />
        <span className={triggerBg()} />
      </Accordion.Trigger>
    </Accordion.Header>
  );
};

export { OpenItemHeader };
